import CloseIcon from '@mui/icons-material/Close';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Button as MuiButton,
} from '@mui/material';
import { useCallback } from 'react';
import { BootstrapDialog } from './shared/BootstrapDialog';

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  id,
  isPending,
  okText,
  noText,
  disabled,
}) => {
  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!disabled && !isPending) {
        onConfirm(id);
      }
    },
    [disabled, isPending, onConfirm, id],
  );

  return (
    <BootstrapDialog
      open={open}
      onClose={onClose}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
      }}
      maxWidth="md"
    >
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <MuiButton onClick={onClose} variant="default" type="button">
          {noText || 'Cancel'}
        </MuiButton>
        <MuiButton variant="contained" type="submit" color="error" disabled={disabled || isPending}>
          {isPending ? 'Deleting' : okText || 'Delete'}
        </MuiButton>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default DeleteConfirmationDialog;
